import React from "react";
import styled from "styled-components";
import Tile from "../Tile";
import { DEFAULT_TILE_WIDTH, DEFAULT_TILE_HEIGHT } from "../Tile/Tile";
import { spriteKey } from "../../engine/solitaire";

// 13, not 14: at 14 the slice lands exactly on the face cards' inner
// frame line and a sliver of border peeks through.
const FAN_HORIZONTAL_OFFSET = 13;
const FAN_VERTICAL_OFFSET = 1;
const MAX_FAN_CARDS = 3;

// Shows the current waste fan — up to the last `visibleCount` drawn cards,
// fanned from upper-left down to the visible top on the right. Earlier
// waste cards are hidden; only the top is playable. The fan overflows
// rightward beyond one card-width; the Board reserves an empty grid column
// next to Waste to absorb the overflow.
//
// onClick/selected attach only to the topmost (rightmost) card — the fan
// cards beneath are decorative; only the top is playable.
function Waste({ cards, visibleCount, onClick, selected = false, sourceTag }) {
  const count = Math.min(
    visibleCount != null ? visibleCount : MAX_FAN_CARDS,
    cards.length,
  );
  // One squared-up card UNDER the fan whenever more waste exists below
  // it. Invisible in the resting state, but the moment a drag lifts
  // (hides) the top card of a 1-card fan, the next card is already
  // there — classic MS revealed it on pickup, not on drop.
  const under = count > 0 && cards.length > count ? 1 : 0;
  const visible = count > 0 ? cards.slice(-(count + under)) : [];
  return (
    <Wrapper>
      {visible.map((card, i) => {
        const isTop = i === visible.length - 1;
        const fanIdx = Math.max(0, i - under);
        return (
          <Positioned
            key={i}
            style={{
              left: fanIdx * FAN_HORIZONTAL_OFFSET,
              top: fanIdx * FAN_VERTICAL_OFFSET,
            }}
          >
            <Tile
              name={spriteKey(card)}
              {...(isTop && onClick ? { as: "button", onClick } : {})}
              selected={isTop && selected}
              data-card-source={isTop && sourceTag ? sourceTag : undefined}
            />
          </Positioned>
        );
      })}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  position: relative;
  width: ${DEFAULT_TILE_WIDTH}px;
  height: ${DEFAULT_TILE_HEIGHT}px;
`;

const Positioned = styled.div`
  position: absolute;
`;

export default Waste;
